// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2gT_R","imageUploader":"EGiftCard_imageUploader__Q6dxs"};